export const createInteractionMode = () => {
  // State
  let mode = 'click';
  let isTokenDragging = true;
  let listeners = [];

  // Methods
  const setMode = (newMode) => {
    mode = newMode;
    // Only allow token dragging in click mode
    isTokenDragging = mode === 'click';
    notifyListeners();
  };

  const getMode = () => mode;
  const getIsTokenDragging = () => isTokenDragging;
  
  const setTokenDragging = (value) => {
    if (mode === 'click') {
      isTokenDragging = value;
      notifyListeners();
    }
  };

  // Observer pattern for state changes
  const subscribe = (listener) => {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  };

  const notifyListeners = () => {
    listeners.forEach(listener => listener({
      mode,
      isTokenDragging
    }));
  };

  return {
    setMode,
    getMode,
    getIsTokenDragging,
    setTokenDragging,
    subscribe
  };
};